import { useAuth } from "../App";
import { Bell, Search, User, ChevronDown } from "lucide-react";
import { useLocation } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "../components/ui/avatar";

const Header = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const getPageTitle = () => {
    const paths = {
      "/": "Dashboard",
      "/dashboard": "Dashboard",
      "/campaigns": "Campaigns",
      "/users": "Users",
      "/user-groups": "User Groups",
      "/email-templates": "Email Templates",
      "/landing-pages": "Landing Pages",
      "/offenders": "Offenders",
      "/department-heatmap": "Department Risk Heatmap",
      "/human-risk-scorecard": "Human Risk Scorecard",
      "/insider-risk": "Insider Risk Indicators",
      "/settings": "Settings",
    };
    return paths[location.pathname] || "Phishing Tool";
  };

  const getRoleBadgeColor = (role) => {
    switch (role) {
      case "admin": return "bg-[#8c3add]/10 text-[#8c3add]";
      case "manager": return "bg-[#1fa7a1]/10 text-[#1fa7a1]";
      default: return "bg-gray-100 text-gray-600";
    }
  };

  return (
    <header
      className="h-16 bg-white/80 backdrop-blur-md border-b border-gray-200 sticky top-0 z-40 px-6 flex items-center justify-between"
      data-testid="header"
    >
      {/* Page Title */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="text-gray-400 text-sm">≡</span>
          <h1 className="text-lg font-semibold text-[#1f1f23] tracking-tight">
            {getPageTitle()}
          </h1>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-4">
        {/* Search */}
        <div className="relative hidden md:block">
          {/* <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
          <input
            type="text"
            placeholder="Search..."
            className="w-64 pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#8c3add]/20 focus:border-[#8c3add] transition-all"
            data-testid="header-search"
          /> */}
        </div>

        {/* Notifications */}
        {/* <button
          className="relative p-2 rounded-xl hover:bg-gray-100 transition-colors"
          data-testid="notifications-button"
        >
          <Bell size={20} className="text-gray-600" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button> */}

        {/* User Menu */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              className="flex items-center gap-3 p-1.5 pr-3 rounded-xl hover:bg-gray-50 transition-colors"
              data-testid="user-menu-trigger"
            >
              <Avatar className="h-8 w-8 border-2 border-[#8c3add]/20">
                <AvatarImage src="" />
                <AvatarFallback className="bg-[#8c3add] text-white text-sm font-medium">
                  {user?.name?.charAt(0) || "U"}
                </AvatarFallback>
              </Avatar>
              <div className="hidden sm:block text-left">
                <p className="text-sm font-medium text-[#1f1f23]">
                  {user?.name || "User"}
                </p>
                <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
              </div>
              <ChevronDown size={16} className="text-gray-400 hidden sm:block" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <div className="px-3 py-2">
              <p className="font-medium text-sm">{user?.name}</p>
              <p className="text-xs text-gray-500">{user?.email}</p>
              <span className={`inline-block mt-1 px-2 py-0.5 rounded-full text-xs font-medium capitalize ${getRoleBadgeColor(user?.role)}`}>
                {user?.role}
              </span>
            </div>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onSelect={() => {
                window.location.href = "/settings";
              }}
              className="cursor-pointer"
              data-testid="menu-profile"
            >
              <User className="mr-2 h-4 w-4" />
              Profile
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={logout}
              className="cursor-pointer text-red-600 focus:text-red-600"
              data-testid="menu-logout"
            >
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default Header;
